import React from 'react';
import styled from 'styled-components';
import config from 'config';

const Image = styled('img')`
    width: 0px;
    height: 0px;
`;

const TrackingPixel = () => {
    const urlParams = window.location.search.substring(1).split('&');
    const referrer = encodeURIComponent(document.referrer);
    let clickId = '';
    let refid = '';
    let ip = '';

    urlParams.forEach(pair => {
        pair = pair.split('=');

        if (pair[0] === 'refclickid') {
            clickId = pair[1];
        } else if (pair[0] === 'refid') {
            refid = pair[1];
        } else if (pair[0] === 'ipaddr') {
            ip = `&ipaddr=${pair[1]}`;
        }
    });

    return (
        <Image alt="" src={`${config.ROOT_DIR}images/pixel.gif?refclickid=${clickId}&refid=${refid}&referrer=${referrer}${ip}`} />
    );
};

export const AMPTrackingPixel = () => (
    <amp-pixel
        src="https://www.priceline.com/hotel-deals/images/pixel.gif?refclickid=QUERY_PARAM(refclickid)&refid=QUERY_PARAM(refid)&referrer=DOCUMENT_REFERRER"
        layout="nodisplay"
    />
);

export default TrackingPixel;
